import React, { FunctionComponent } from "react";
import { twMerge } from "tailwind-merge";

type LeadTextProps = {
  center?: boolean;
  className?: string;
  dark?: boolean;
};

const LeadText: FunctionComponent<LeadTextProps> = ({
  children,
  center = false,
  className,
  dark = false,
}) => {
  return (
    <p
      className={twMerge(
        "text-xl leading-snug md:text-2xl",
        dark ? "text-gray-300" : "text-gray-600",
        center && "text-center",
        className,
      )}
    >
      {children}
    </p>
  );
};

export default LeadText;
